var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.333 32H18.9997C15.3178 32 12.333 29.0152 12.333 25.3333V8.66667C12.333 4.98477 15.3178 2 18.9997 2H28.9997C32.6816 2 35.6663 4.98477 35.6663 8.66667V20.3333M2.33301 8.66667H7.33301M18.9997 8.66667H28.9997M18.9997 15.3333H28.9997M18.9997 22H23.9997M25.6663 28.6667L28.5877 31.0038C29.2842 31.5609 30.2958 31.4711 30.8832 30.7998L35.6663 25.3333M4.83301 32L5.99967 30.4444C6.86516 29.2905 7.33301 27.8869 7.33301 26.4444V4.5C7.33301 3.11929 6.21372 2 4.83301 2C3.4523 2 2.33301 3.11929 2.33301 4.5V26.4444C2.33301 27.8869 2.80086 29.2905 3.66634 30.4444L4.83301 32Z",
    stroke: "#25A249",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.570e2c319ad413ec6342e4bd7f951676.svg";
export { ForwardRef as ReactComponent };